"use strict";
exports.__esModule = true;
exports.isEmailBasic = exports.isValidArgosEmailTopLevelDomain = exports.isValidArgosEmailCharacters = exports.isEmail = void 0;
// Email pattern based on http://emailregex.com/ Removed support for ip and port numbers and added in #/`
var EMAIL_PATTERN = /^[-a-z0-9~!$%^&`/#*_=+}{'?]+(\.[-a-z0-9~!$%^`/&#*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,63}))?$/i;
var EMAIL_BASIC_PATTERN = /^(?=.*[@])(?=.*[.]).+$/;
var ARGOS_EMAIL_PATTERN = /^[^\\",;:[\]<>(){}!%`?$^&*|#=+/~]+$/;
var ARGOS_EMAIL_TOP_LEVEL_DOMAIN_PATTERN = /\.[a-zA-Z]{2,4}$/;
function isEmail(value) {
    return value.match(EMAIL_PATTERN) !== null;
}
exports.isEmail = isEmail;
/**
 * Validates against characters that are valid in an email address, but not valid by argos standards e.g. foo+bar@baz.com
 * Unique validation check so it can have a distinct and accurate error message
 */
function isValidArgosEmailCharacters(value) {
    return value.match(ARGOS_EMAIL_PATTERN) !== null;
}
exports.isValidArgosEmailCharacters = isValidArgosEmailCharacters;
/**
 * Validates the top level domain is not to long e.g. We do not support foo@bar.london
 * Unique validation check so it can have a distinct and accurate error message
 */
function isValidArgosEmailTopLevelDomain(value) {
    return value.match(ARGOS_EMAIL_TOP_LEVEL_DOMAIN_PATTERN) !== null;
}
exports.isValidArgosEmailTopLevelDomain = isValidArgosEmailTopLevelDomain;
/**
 * Validates the email contains a . and a @ as this is the most common mistake in email entry
 * Unique validation check so it can have a distinct error message
 */
function isEmailBasic(value) {
    return value.match(EMAIL_BASIC_PATTERN) !== null;
}
exports.isEmailBasic = isEmailBasic;
//# sourceMappingURL=email.js.map